import React from "react";

// Full-page white dotted-grid background (styling handled in index.css body).
// Renders soft radial glow layers used behind the active step card.
export default function GridBackground({ children }) {
  return (
    <div className="relative min-h-screen w-full overflow-x-hidden">
      <div className="pointer-events-none fixed inset-0 -z-10">
        <div className="absolute top-[-10%] left-[-5%] w-[45vw] h-[45vw] rounded-full bg-hoh-blush/40 blur-[120px]" />
        <div className="absolute bottom-[-10%] right-[-5%] w-[40vw] h-[40vw] rounded-full bg-hoh-lavender/40 blur-[120px]" />
      </div>
      {children}
    </div>
  );
}
